module.exports = {"title":"Quelques questions pour découvrir @:txt.space…","framaspace":{"title":"@:(txt.space)"},"nextcloud":{"title":"Nextcloud"}};